// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectSettingsControlEmployee_wrapper__2fDmq","title":"ProjectSettingsControlEmployee_title__1mk5A","empty":"ProjectSettingsControlEmployee_empty__2xH2t"};